/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * Store the list of geopolitical views available as key-value pairs.
 *
 * By default, all the entries listed here are supported by the supported services defined in the geopolView class.
 * If a view is NOT supported by a service it needs to be added as a fallback here.
 *
 * Note: maps service have subTypes. If a view is not supported by a service + subType (ex: maps - raster), we need to
 * add its fallback here.
 */
define([], function() {
    'use strict';
    return {
        Unified: {
            label: 'Unified'
        },
        IN: {
            label: 'India'
        },
        IL: {
            label: 'Israel'
        },
        MA: {
            label: 'Morocco'
        },
        PK: {
            label: 'Pakistan'
        },
        AR: {
            label: 'Argentina',
            search: {
                fallback: 'Unified'
            }
        },
        Arabic: {
            label: 'Arabic',
            search: {
                fallback: 'Unified'
            },
            reverseGeocoder: {
                fallback: 'Unified'
            }
        }
    };
});



// WEBPACK FOOTER //
// ./config/geopolView/geopolViewsMapping.js